// extracted by mini-css-extract-plugin
export default {"files-table":"jOwkxI2eQ_gpWZB2Waaj","icon-label":"_VQGt07dRWGXvVC9QX02","audit-container":"ArjiVjQZMLnDatQkAWoU"};